/**
 * What Sentry may collect, shared by every `Sentry.init` of the dashboard.
 *
 * Left unset, the SDK collects cookies, user info and every HTTP body, which
 * here would include the `auth` cookie, the login form and the tokens returned
 * by trigger-api. This is the SDK's restrictive baseline: no cookies, no
 * bodies, no user info, and headers and query parameters without network
 * identity. Sentry's own filtering of keys and tokens still applies on top.
 */
const NETWORK_IDENTITY = ['forwarded', '-ip', 'remote-', 'via', '-user']

export const sentryDataCollection = {
  userInfo: false,
  cookies: false,
  httpHeaders: {
    request: { deny: NETWORK_IDENTITY },
    response: { deny: NETWORK_IDENTITY },
  },
  httpBodies: [],
  urlQueryParams: { deny: NETWORK_IDENTITY },
  genAI: { inputs: false, outputs: false },
  databaseQueryData: false,
  queues: false,
  graphQL: { document: false, variables: false },
}
